export const CATEGORIES_WITH_NAME_AS_KEY = ['division', 'city'];
